/* =====================================================================
   Maison Stiletto (V5 adapte) : panier, window.MPCart
   Charge en defer par sections/mp-global.liquid, apres mp-base.js (window.MP) et avant les scripts de surface.
   Racines : le tiroir [data-mp-cart-drawer] (section mp-cart-drawer, groupe de pied de page) et la page
   [data-mp-cart-page] (section mp-cart-page). Chacune porte data-section-id et contient [data-mp-cart-body],
   dont le contenu est remplace apres chaque action par la Section Rendering API (reponse groupee de
   cart/add.js, cart/change.js et cart/update.js avec "sections", sinon ?sections=).

   Contrat (SPEC-V5 3.3, FONDATIONS 11) :
     MPCart.open(opener?)          ouvre le tiroir (MP.layer) ; sans effet sur la page /cart
     MPCart.close()                ferme le tiroir
     MPCart.refresh(open?)         recharge le contenu (et ouvre si open) -> Promise<state>
     MPCart.add(items)             POST /cart/add.js, recharge, ouvre -> Promise<reponse Shopify>,
                                   rejet avec l'objet d'erreur Shopify { status, message, description }
   En plus : change(key, quantity), applyCode(code), removeCode(code), isOpen(), state().
   Apres chaque mise a jour : [data-mp-cart-count] (texte, hidden si 0) et
   document -> CustomEvent('mp:cart:updated', { detail: { item_count, total_price, source } }).
   Ouvre le tiroir au clic sur [data-mp-cart-open] ou a[href$="/cart"] (phase capture), sauf sur le template cart.
   ===================================================================== */
(function () {
  'use strict';

  if (window.MPCart && window.MPCart.__v5) return; // deja charge
  var MP = window.MP;
  if (!MP || !MP.layer) return; // sans mp-base.js les liens /cart restent de simples liens

  var doc = document;

  var SEL = {
    root: '[data-mp-cart-root]',
    drawer: '[data-mp-cart-drawer]',
    page: '[data-mp-cart-page]',
    body: '[data-mp-cart-body]',
    scroll: '[data-mp-cart-scroll]',
    state: 'script[data-mp-cart-state]',
    item: '[data-mp-cart-item]'
  };

  /* ---------- Textes : bloc <script data-mp-i18n="cart"> rendu par snippets/mp-cart-body, repli anglais ----------
     [jeton] dans une chaine = valeur passee a tr(cle, { jeton: valeur }). */
  var FALLBACK = {
    code_empty: 'Enter a code.',
    code_already: 'This code is already applied.',
    code_refused: 'This code isn’t valid for your bag.',
    select_size: 'Select a size.',
    removed: 'Item removed from your bag.',
    qty_updated: 'Quantity updated: [n].',
    code_applied: 'Code [code] applied.',
    code_removed: 'Code [code] removed.'
  };
  function tr(key, vars) {
    // MP.t (mp-base.js) lit le meme bloc ; repli local si absent
    if (typeof MP.t === 'function') return MP.t('cart', key, FALLBACK[key], vars);
    var s = null;
    var el = doc.querySelector('script[data-mp-i18n="cart"]');
    if (el) {
      var d = el.__mpDict;
      if (!d) {
        try { d = JSON.parse(el.textContent || '{}') || {}; } catch (e) { d = {}; }
        el.__mpDict = d;
      }
      if (typeof d[key] === 'string' && d[key] !== '') s = d[key];
    }
    if (s == null) s = FALLBACK[key];
    if (s == null) return '';
    if (vars) {
      Object.keys(vars).forEach(function (k) { s = s.split('[' + k + ']').join(String(vars[k])); });
    }
    return s;
  }

  /* ---------- Outils ---------- */
  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function cfg() { return MP.config || {}; }
  function routes() { return cfg().routes || {}; }
  function cartUrl() { return routes().cart || '/cart'; }
  function onCartPage() { return cfg().template === 'cart'; }
  function drawer() { return doc.querySelector(SEL.drawer); }
  function pageRoot() { return doc.querySelector(SEL.page); }
  function hasBody(root) {
    var b = root && root.querySelector(SEL.body);
    return !!(b && b.children.length);
  }
  // racine a mettre a jour pour une action venue d'ailleurs (fiche, carte, en-tete)
  function mainRoot() {
    var r = onCartPage() ? pageRoot() : drawer();
    return r && hasBody(r) ? r : null;
  }
  function sectionId(root) { return root ? root.getAttribute('data-section-id') || '' : ''; }
  function focusEl(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function same(a, b) { return String(a).toLowerCase() === String(b).toLowerCase(); }

  /* ---------- Etat (lu dans le JSON rendu par le snippet) ---------- */
  var state = { item_count: 0, total_price: 0, codes: [], applicable: [] };

  function readState(scope) {
    var el = scope && scope.querySelector(SEL.state);
    if (!el) return null;
    try {
      var j = JSON.parse(el.textContent || '{}');
      return {
        item_count: Number(j.count) || 0,
        total_price: Number(j.total) || 0,
        codes: Array.isArray(j.codes) ? j.codes : [],
        applicable: Array.isArray(j.applicable) ? j.applicable : []
      };
    } catch (e) {
      return null;
    }
  }
  function stateFromCart(j) {
    var codes = (j && j.discount_codes) || [];
    return {
      item_count: Number(j && j.item_count) || 0,
      total_price: Number(j && j.total_price) || 0,
      codes: codes.map(function (c) { return c.code; }),
      applicable: codes.filter(function (c) { return c.applicable !== false; }).map(function (c) { return c.code; })
    };
  }
  function currentState(root) { return (root && readState(root)) || state; }

  // diffuse l'etat : compteurs de l'en-tete + evenement pour les autres surfaces
  function publish(st, source) {
    if (!st) return;
    state = st;
    toArray(doc.querySelectorAll('[data-mp-cart-count]')).forEach(function (el) {
      el.textContent = String(st.item_count);
      if (st.item_count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    // pastille de Horizon si son en-tete est encore present quelque part
    toArray(doc.querySelectorAll('cart-icon')).forEach(function (c) {
      if (typeof c.renderCartBubble === 'function') {
        try { c.renderCartBubble(st.item_count); } catch (e) { /* sans effet */ }
      }
    });
    MP.emit(doc, 'mp:cart:updated', { item_count: st.item_count, total_price: st.total_price, source: source || 'refresh' });
  }

  /* ---------- Reseau ---------- */
  // POST JSON ; rejet avec l'objet d'erreur Shopify ({ status, message, description }) pour MP.errorText
  function request(url, data) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.text().then(function (t) {
        var j = null;
        try { j = t ? JSON.parse(t) : {}; } catch (e) { j = null; }
        if (!r.ok) throw (j && typeof j === 'object') ? j : { status: r.status, message: 'HTTP ' + r.status, description: '' };
        return j || {};
      });
    }, function (e) {
      throw { status: 0, message: (e && e.message) || 'Failed to fetch', description: '' };
    });
  }
  function getCart() {
    return fetch(cartUrl() + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
  }
  // demande a Shopify de rendre la section du panier dans la meme reponse (un seul aller-retour)
  function withSections(data, root) {
    var id = sectionId(root);
    if (id && hasBody(root)) {
      data.sections = id;
      data.sections_url = window.location.pathname;
    }
    return data;
  }

  /* ---------- File d'attente : une requete a la fois, dans l'ordre ---------- */
  var chain = Promise.resolve();
  var inflight = 0;
  function setBusy(on) {
    toArray(doc.querySelectorAll(SEL.root)).forEach(function (r) {
      r.classList.toggle('is-busy', on);
      var b = r.querySelector(SEL.body);
      if (!b) return;
      if (on) b.setAttribute('aria-busy', 'true');
      else b.removeAttribute('aria-busy');
    });
  }
  function queue(task) {
    inflight++;
    setBusy(true);
    var p = chain.then(task);
    var done = function () {
      inflight--;
      if (!inflight) setBusy(false);
    };
    chain = p.then(done, done);
    return p;
  }

  /* ---------- Rendu ---------- */
  var ro = ('ResizeObserver' in window) ? new ResizeObserver(function (entries) {
    entries.forEach(function (en) {
      var r = en.target.closest(SEL.root);
      if (r) measure(r);
    });
  }) : null;

  // filet au-dessus du pied quand des articles defilent dessous ; filet sous l'en-tete des qu'on a defile
  function measure(root) {
    if (!root.matches(SEL.drawer)) return;
    var sc = root.querySelector(SEL.scroll);
    root.classList.toggle('is-overflow', !!sc && sc.scrollHeight - sc.clientHeight > 1);
    root.classList.toggle('is-scrolled', !!sc && sc.scrollTop > 0);
  }
  function onScroll(e) {
    var sc = e.currentTarget;
    var r = sc.closest(SEL.root);
    if (r) r.classList.toggle('is-scrolled', sc.scrollTop > 0);
  }
  function watch(root) {
    if (!root) return;
    var sc = root.querySelector(SEL.scroll);
    if (sc && !sc.__mpWatched) {
      sc.__mpWatched = true;
      sc.addEventListener('scroll', onScroll, { passive: true });
      if (ro) ro.observe(sc);
    }
    measure(root);
  }

  // les scripts des boutons de paiement express ne s'executent pas via innerHTML : on les recree
  function runScripts(scope) {
    if (!scope) return;
    toArray(scope.querySelectorAll('script')).forEach(function (old) {
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'text/javascript' && type !== 'module' && type !== 'application/javascript') return;
      var s = doc.createElement('script');
      toArray(old.attributes).forEach(function (a) { s.setAttribute(a.name, a.value); });
      s.text = old.text;
      old.parentNode.replaceChild(s, old);
    });
    try {
      var ex = window.Shopify && window.Shopify.StorefrontExpressButtons;
      if (ex && typeof ex.initialize === 'function') ex.initialize();
    } catch (e) { /* boutons express indisponibles : le bouton Checkout suffit */ }
  }

  function restoreFocus(root, body, key) {
    var target = null;
    if (key) {
      toArray(body.querySelectorAll('[data-mp-focus]')).some(function (el) {
        if (el.getAttribute('data-mp-focus') === key && el.getClientRects().length) {
          target = el;
          return true;
        }
        return false;
      });
    }
    focusEl(target || root.querySelector('[data-mp-cart-title]'));
  }

  // remplace le contenu de [data-mp-cart-body] en gardant defilement, focus, code saisi et barre animee
  function applyDoc(root, fresh) {
    var src = fresh && fresh.querySelector(SEL.body);
    var body = root && root.querySelector(SEL.body);
    if (!src || !body) return false;

    var sc = body.querySelector(SEL.scroll);
    var top = sc ? sc.scrollTop : 0;
    var active = doc.activeElement;
    var hadFocus = !!(active && active !== body && body.contains(active));
    var focusKey = hadFocus ? active.getAttribute('data-mp-focus') : null;
    var box = body.querySelector('[data-mp-cart-code]');
    var boxOpen = !!(box && box.open);
    var input = body.querySelector('[data-mp-cart-code-input]');
    var typed = input ? input.value : '';
    var ship = body.querySelector('[data-mp-cart-ship]');
    var shipFrom = ship ? ship.style.getPropertyValue('--mp-ship') : '';
    if (ro && sc) ro.unobserve(sc);

    body.innerHTML = src.innerHTML;

    var nsc = body.querySelector(SEL.scroll);
    if (nsc) nsc.scrollTop = top;
    var nbox = body.querySelector('[data-mp-cart-code]');
    if (nbox && boxOpen) nbox.open = true;
    var ninput = body.querySelector('[data-mp-cart-code-input]');
    if (ninput && typed) ninput.value = typed;
    var nship = body.querySelector('[data-mp-cart-ship]');
    if (nship && shipFrom) {
      var shipTo = nship.style.getPropertyValue('--mp-ship');
      if (shipTo && shipTo !== shipFrom) {
        nship.style.setProperty('--mp-ship', shipFrom);
        void nship.offsetWidth; // la transition part de l'ancienne valeur
        nship.style.setProperty('--mp-ship', shipTo);
      }
    }
    runScripts(body.querySelector('[data-mp-cart-express]'));
    MP.eta(body);
    watch(root);
    if (hadFocus) restoreFocus(root, body, focusKey);
    return true;
  }
  function applyHTML(root, html) {
    if (!root || typeof html !== 'string') return false;
    return applyDoc(root, new DOMParser().parseFromString(html, 'text/html'));
  }

  // apres une requete : rendu depuis la reponse groupee, sinon ?sections=, sinon /cart.js (compteurs seuls)
  function settle(root, res, source) {
    var id = sectionId(root);
    var html = res && res.sections && id ? res.sections[id] : null;
    if (root && html && applyHTML(root, html)) {
      publish(currentState(root), source);
      return Promise.resolve(state);
    }
    if (root && id && hasBody(root)) {
      return MP.section(id).then(function (d) {
        if (!applyDoc(root, d)) throw new Error('Bag render failed');
        publish(currentState(root), source);
        return state;
      });
    }
    return getCart().then(function (j) {
      publish(stateFromCart(j), source);
      return state;
    });
  }
  // rendu impossible (section retiree, erreur serveur) : la page /cart fait foi
  function fallback(root) {
    if (onCartPage()) {
      window.location.reload();
      return Promise.resolve(state);
    }
    return getCart().then(function (j) {
      publish(stateFromCart(j), 'refresh');
      return state;
    }, function () { return state; });
  }

  /* ---------- Ouverture ---------- */
  function open(opener) {
    if (onCartPage()) return false;
    var d = drawer();
    if (!d || !hasBody(d)) {
      window.location.href = cartUrl();
      return false;
    }
    MP.portal(d);
    MP.layer.open(d, opener && opener.nodeType === 1 ? opener : doc.activeElement);
    watch(d);
    return true;
  }
  function close() {
    var d = drawer();
    if (d && MP.layer.isOpen(d)) MP.layer.close();
  }

  /* ---------- API ---------- */
  function normalize(items) {
    if (items == null) return [];
    if (typeof items === 'number' || typeof items === 'string') items = [{ id: items, quantity: 1 }];
    if (!Array.isArray(items)) items = [items];
    return items.map(function (it) {
      if (typeof it === 'number' || typeof it === 'string') it = { id: it };
      var o = { id: Number(it && it.id), quantity: Math.max(1, parseInt(it && it.quantity, 10) || 1) };
      if (it && it.properties) o.properties = it.properties;
      if (it && it.selling_plan) o.selling_plan = it.selling_plan;
      return o;
    }).filter(function (it) { return it.id > 0; });
  }

  function add(items) {
    var list = normalize(items);
    if (!list.length) return Promise.reject({ status: 422, message: tr('select_size'), description: tr('select_size') });
    var root = mainRoot();
    var opener = doc.activeElement;
    return queue(function () {
      return request(routes().cartAdd || '/cart/add.js', withSections({ items: list }, root)).then(function (res) {
        return settle(root, res, 'add').then(function () { return res; }, function () {
          // article bien ajoute mais rendu impossible : on montre la page panier
          if (onCartPage()) window.location.reload();
          else window.location.href = cartUrl();
          return res;
        });
      });
    }).then(function (res) {
      if (!onCartPage()) open(opener);
      return res;
    });
  }

  function refresh(openAfter) {
    var root = mainRoot();
    return queue(function () {
      return settle(root, null, 'refresh').catch(function () { return fallback(root); });
    }).then(function (st) {
      if (openAfter) open();
      return st;
    });
  }

  function change(root, key, quantity, source) {
    root = root && hasBody(root) ? root : mainRoot();
    return queue(function () {
      return request(routes().cartChange || '/cart/change.js', withSections({ id: String(key), quantity: quantity }, root)).then(function (res) {
        return settle(root, res, source || 'change').catch(function () { return fallback(root); }).then(function () { return res; });
      });
    });
  }

  /* ---------- Quantites : affichage immediat, envoi groupe apres 350 ms ---------- */
  var timers = {};
  function schedule(key, fn) {
    if (timers[key]) clearTimeout(timers[key].t);
    timers[key] = {
      fn: fn,
      t: setTimeout(function () {
        delete timers[key];
        fn();
      }, 350)
    };
  }
  function flush() {
    Object.keys(timers).forEach(function (k) {
      var job = timers[k];
      clearTimeout(job.t);
      delete timers[k];
      job.fn();
    });
    return chain;
  }
  function pendingWork() { return Object.keys(timers).length > 0 || inflight > 0; }

  function findItem(root, key) {
    var found = null;
    toArray(root.querySelectorAll(SEL.item)).some(function (it) {
      if (it.getAttribute('data-key') === key) { found = it; return true; }
      return false;
    });
    return found;
  }
  function lineMessage(root, key, text) {
    var it = findItem(root, key);
    var msg = it && it.querySelector('[data-mp-cart-line-msg]');
    if (msg) msg.textContent = text;
    MP.announce(text);
  }
  function setQty(item, n) {
    item.setAttribute('data-qty', String(n));
    var out = item.querySelector('[data-mp-cart-qty-n]');
    if (out) {
      var last = out.lastChild;
      if (last && last.nodeType === 3) last.nodeValue = String(n);
      else out.appendChild(doc.createTextNode(String(n)));
    }
    var minus = item.querySelector('[data-mp-cart-qty="-1"]');
    if (minus) {
      if (n <= 1) minus.setAttribute('aria-disabled', 'true');
      else minus.removeAttribute('aria-disabled');
    }
  }
  function resync(root) {
    return queue(function () {
      return settle(root, null, 'change').catch(function () { return fallback(root); });
    });
  }
  function bump(root, btn) {
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var item = btn.closest(SEL.item);
    if (!item) return;
    var key = item.getAttribute('data-key');
    var cur = parseInt(item.getAttribute('data-qty'), 10) || 1;
    // le moins s'arrete a 1 : seule la corbeille retire une piece (pas de suppression sur un pouce qui rate)
    var next = Math.max(1, cur + (parseInt(btn.getAttribute('data-mp-cart-qty'), 10) || 0));
    if (next === cur) return;
    setQty(item, next);
    item.classList.add('is-pending');
    var msg = item.querySelector('[data-mp-cart-line-msg]');
    if (msg) msg.textContent = '';
    schedule(key, function () {
      return change(root, key, next, 'quantity').then(function () {
        MP.announce(tr('qty_updated', { n: next }));
      }, function (err) {
        return resync(root).then(function () { lineMessage(root, key, MP.errorText(err)); });
      });
    });
  }
  function remove(root, link) {
    var item = link.closest(SEL.item);
    if (!item) return;
    var key = item.getAttribute('data-key');
    if (timers[key]) {
      clearTimeout(timers[key].t);
      delete timers[key];
    }
    item.classList.add('is-pending');
    change(root, key, 0, 'remove').then(function () {
      MP.announce(tr('removed'));
    }, function (err) {
      item.classList.remove('is-pending');
      lineMessage(root, key, MP.errorText(err));
    });
  }

  /* ---------- Codes promo : cart/update.js { discount: 'A,B' } ---------- */
  function codeEls(root) {
    return {
      box: root.querySelector('[data-mp-cart-code]'),
      input: root.querySelector('[data-mp-cart-code-input]'),
      msg: root.querySelector('[data-mp-cart-code-msg]')
    };
  }
  function codeMessage(root, text, code) {
    var c = codeEls(root);
    if (c.box) c.box.open = true;
    if (c.input) {
      if (code != null) c.input.value = code;
      if (text) c.input.setAttribute('aria-invalid', 'true');
      else c.input.removeAttribute('aria-invalid');
    }
    if (c.msg) c.msg.textContent = text || '';
    if (text) MP.announce(text);
  }
  // true / false selon la reponse de Shopify, null si elle ne le dit pas
  function verdict(res, code) {
    var list = res && res.discount_codes;
    if (!Array.isArray(list)) return null;
    var hit = null;
    list.forEach(function (d) { if (same(d.code, code)) hit = d; });
    if (!hit) return false;
    return hit.applicable !== false;
  }
  function applyCode(root, raw) {
    if (!root) return Promise.reject({ message: 'Bag unavailable' });
    var code = String(raw || '').trim();
    if (!code) {
      codeMessage(root, tr('code_empty'));
      focusEl(codeEls(root).input);
      return Promise.resolve(false);
    }
    var keep = (currentState(root).applicable || []).slice();
    if (keep.some(function (c) { return same(c, code); })) {
      codeMessage(root, tr('code_already'), code);
      return Promise.resolve(true);
    }
    var url = routes().cartUpdate || '/cart/update.js';
    // code refuse : retire aussitot (sinon il reste accroche au panier) puis message en ligne
    function drop() {
      return request(url, withSections({ discount: keep.join(',') }, root)).then(function (r2) {
        return settle(root, r2, 'code');
      }).then(function () {
        codeMessage(root, tr('code_refused'), code);
        return false;
      });
    }
    return queue(function () {
      return request(url, withSections({ discount: keep.concat(code).join(',') }, root)).then(function (res) {
        var ok = verdict(res, code);
        if (ok === false) return drop();
        // code accepte : champ vide, volet replie, la puce du code apparait sous le volet
        var c = codeEls(root);
        if (c.input) c.input.value = '';
        if (c.box) c.box.open = false;
        return settle(root, res, 'code').then(function () {
          if (ok === null && !(currentState(root).applicable || []).some(function (x) { return same(x, code); })) return drop();
          codeMessage(root, '');
          var box = codeEls(root).box;
          if (box) box.open = false;
          focusEl(root.querySelector('[data-mp-cart-code] > summary'));
          MP.announce(tr('code_applied', { code: code }));
          return true;
        });
      });
    }).catch(function (err) {
      codeMessage(root, MP.errorText(err), code);
      return false;
    });
  }
  function removeCode(root, code) {
    if (!root) return Promise.reject({ message: 'Bag unavailable' });
    var keep = (currentState(root).applicable || []).filter(function (c) { return !same(c, code); });
    return queue(function () {
      return request(routes().cartUpdate || '/cart/update.js', withSections({ discount: keep.join(',') }, root)).then(function (res) {
        return settle(root, res, 'code');
      });
    }).then(function () {
      focusEl(root.querySelector('[data-mp-cart-code] > summary'));
      MP.announce(tr('code_removed', { code: code }));
      return true;
    }, function (err) {
      codeMessage(root, MP.errorText(err));
      return false;
    });
  }

  /* ---------- Suggestions "Complete your look" : taille choisie = id du bouton "+ Add" (ajout par mp-base) ---------- */
  function nudgeSize(btn) {
    var wrap = btn.closest('[data-mp-quick]');
    var sel = wrap && wrap.querySelector('[data-mp-cart-size]');
    if (!sel) return;
    sel.setAttribute('aria-invalid', 'true');
    sel.classList.remove('mp-shake');
    void sel.offsetWidth;
    sel.classList.add('mp-shake');
    setTimeout(function () { focusEl(sel); }, 0);
  }

  /* ---------- Ecouteurs ---------- */
  // phase capture : ouvrir le tiroir a la place de la page /cart ; taille manquante dans une suggestion
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var qa = t.closest('.mp-cart [data-mp-quick-add]');
    if (qa) {
      if (!qa.getAttribute('data-mp-quick-add')) nudgeSize(qa);
      return;
    }
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var trg = t.closest('[data-mp-cart-open], a[href$="/cart"]');
    if (!trg || onCartPage() || trg.closest(SEL.root) || trg.hasAttribute('data-mp-cart-ignore')) return;
    var d = drawer();
    if (!d || !hasBody(d)) return;
    e.preventDefault();
    open(trg);
  }, true);

  // actions dans le panier (tiroir ou page)
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var root = t.closest(SEL.root);
    if (!root) return;
    var q = t.closest('[data-mp-cart-qty]');
    if (q) {
      e.preventDefault();
      bump(root, q);
      return;
    }
    var rm = t.closest('[data-mp-cart-remove]');
    if (rm) {
      e.preventDefault();
      remove(root, rm);
      return;
    }
    var un = t.closest('[data-mp-cart-uncode]');
    if (un) {
      e.preventDefault();
      removeCode(root, un.getAttribute('data-mp-cart-uncode'));
    }
  });

  doc.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('[data-mp-cart-size]')) return;
    var wrap = sel.closest('[data-mp-quick]');
    var btn = wrap && wrap.querySelector('[data-mp-quick-add]');
    if (btn) btn.setAttribute('data-mp-quick-add', sel.value || '');
    sel.removeAttribute('aria-invalid');
    var msg = wrap && wrap.querySelector('[data-mp-quick-msg]');
    if (msg) msg.textContent = '';
  });

  doc.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('[data-mp-cart-code-input]')) return;
    if (el.getAttribute('aria-invalid') === 'true') {
      el.removeAttribute('aria-invalid');
      var root = el.closest(SEL.root);
      var msg = root && root.querySelector('[data-mp-cart-code-msg]');
      if (msg) msg.textContent = '';
    }
  });

  // formulaire du pied : "Apply" (ou Entree dans le champ) = code ; "Checkout" = envoi natif vers le paiement
  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-mp-cart-form]')) return;
    var root = form.closest(SEL.root);
    var input = form.querySelector('[data-mp-cart-code-input]');
    var sub = e.submitter || null;
    var isCode = sub ? sub.hasAttribute('data-mp-cart-apply') : doc.activeElement === input;
    if (isCode) {
      e.preventDefault();
      applyCode(root, input ? input.value : '');
      return;
    }
    // tiroir : le bouton est hors du formulaire (attribut form), dans .mp-cart__bar
    var btn = form.querySelector('[data-mp-cart-checkout]') || (root && root.querySelector('[data-mp-cart-checkout]'));
    // roue sur "Checkout" seulement (pas quand un bouton de paiement express soumet le formulaire)
    if (btn && (!sub || sub === btn)) btn.classList.add('is-loading');
    if (!pendingWork()) return;
    // des quantites partent encore : on attend la fin pour que le paiement reprenne le bon panier
    e.preventDefault();
    var go = function () {
      // V1.17 : le code promo a son propre formulaire (data-mp-code-form) : le paiement part du formulaire du pied
      var f = (root && root.querySelector('[data-mp-cart-form]:not([data-mp-code-form])')) || form;
      var h = doc.createElement('input');
      h.type = 'hidden';
      h.name = 'checkout';
      h.value = '1';
      f.appendChild(h);
      HTMLFormElement.prototype.submit.call(f);
    };
    flush().then(go, go);
  });

  // retour arriere (cache de page) : le panier a pu changer ailleurs
  window.addEventListener('pageshow', function (e) {
    toArray(doc.querySelectorAll('[data-mp-cart-checkout].is-loading')).forEach(function (b) { b.classList.remove('is-loading'); });
    if (e.persisted) refresh(false).catch(function () { /* compteurs inchanges */ });
  });

  /* ---------- Slider "Complete your look" : fleches a droite du titre, une carte par clic ---------- */
  function sugArrows(track) {
    var duo = track.closest('.mp-cart__duo');
    if (!duo) return;
    var max = track.scrollWidth - track.clientWidth;
    toArray(duo.querySelectorAll('[data-mp-sug-step]')).forEach(function (b) {
      var dir = parseInt(b.getAttribute('data-mp-sug-step'), 10);
      b.disabled = dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2;
    });
  }
  doc.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-mp-sug-step]') : null;
    if (!b) return;
    var duo = b.closest('.mp-cart__duo');
    var track = duo && duo.querySelector('[data-mp-sug-track]');
    var card = track && track.querySelector('.mp-cart__sug');
    if (!card) return;
    e.preventDefault();
    var step = card.getBoundingClientRect().width + 12;
    track.scrollBy({ left: parseInt(b.getAttribute('data-mp-sug-step'), 10) * step, behavior: 'smooth' });
  });
  // l'evenement scroll ne remonte pas : ecoute en phase capture
  doc.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-mp-sug-track]')) sugArrows(t);
  }, true);

  /* ---------- Minuteur de reservation [data-mp-timer] ----------
     Echeance unique gardee dans localStorage : posee la 1re fois qu'un minuteur s'affiche (panier non vide), la meme
     d'une page a l'autre et apres chaque rechargement du panier ; effacee quand le panier est vide. Ecoule : phrase
     neutre (data-expired), pas de relance automatique. Sans stockage (navigation privee) : echeance gardee en memoire. */
  var TIMER_KEY = 'mp-cart-timer-end';
  var timerMem = 0;
  function timerGet() {
    try { return parseInt(window.localStorage.getItem(TIMER_KEY), 10) || 0; } catch (e) { return timerMem; }
  }
  function timerSet(v) {
    timerMem = v;
    try {
      if (v) window.localStorage.setItem(TIMER_KEY, String(v));
      else window.localStorage.removeItem(TIMER_KEY);
    } catch (e) { /* memoire seule */ }
  }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function timerTick() {
    var st = doc.querySelector(SEL.state);
    if (st) {
      var c = null;
      try { c = JSON.parse(st.textContent || '{}').count; } catch (e) { c = null; }
      if (c === 0) { timerSet(0); return; }
    }
    var els = toArray(doc.querySelectorAll('[data-mp-timer]'));
    toArray(doc.querySelectorAll('[data-mp-sug-track]')).forEach(sugArrows);
    if (!els.length) return;
    var total = (parseInt(els[0].getAttribute('data-minutes'), 10) || 10) * 60000;
    var now = Date.now();
    var end = timerGet();
    // pas d'echeance, ou duree raccourcie dans l'editeur : nouvelle echeance
    if (!end || end - now > total) { end = now + total; timerSet(end); }
    var left = end - now;
    els.forEach(function (el) {
      var time = el.querySelector('[data-mp-timer-time]');
      var fill = el.querySelector('[data-mp-timer-fill]');
      if (left <= 0) {
        if (!el.classList.contains('is-expired')) {
          el.classList.add('is-expired');
          var txt = el.querySelector('[data-mp-timer-text]');
          if (txt) txt.textContent = el.getAttribute('data-expired') || '';
        }
        if (fill) fill.style.transform = 'scaleX(0)';
        return;
      }
      var s = Math.ceil(left / 1000);
      if (time) time.textContent = pad2(Math.floor(s / 60)) + ':' + pad2(s % 60);
      if (fill) fill.style.transform = 'scaleX(' + (left / total).toFixed(4) + ')';
      el.classList.toggle('is-low', left < 60000);
    });
  }
  timerTick();
  setInterval(timerTick, 500);

  /* ---------- Montage et editeur de theme ---------- */
  // Le tiroir est deplace dans body (un ancetre du pied de page peut casser position: fixed).
  // Dans l'editeur, l'ancienne copie deplacee survit au nouveau rendu de la section : on la supprime,
  // sinon les reglages modifies ne s'afficheraient jamais.
  function mount(scope) {
    var all = toArray(doc.querySelectorAll(SEL.drawer));
    var keep = (scope && scope.querySelector && scope.querySelector(SEL.drawer)) || all[0] || null;
    all.forEach(function (d) {
      if (d === keep) return;
      if (MP.layer.isOpen(d)) MP.layer.close({ silent: true });
      if (d.parentNode) d.parentNode.removeChild(d);
    });
    if (keep) {
      MP.portal(keep);
      watch(keep);
    }
    toArray(doc.querySelectorAll(SEL.page)).forEach(watch);
    var r = mainRoot();
    var st = r && readState(r);
    if (st) state = st;
  }

  doc.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (!t || !t.querySelector) return;
    if (t.querySelector(SEL.drawer)) {
      mount(t);
      MP.eta(drawer());
    } else if (t.querySelector(SEL.page)) {
      watch(t.querySelector(SEL.page));
    }
  });
  doc.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (!id) return;
    toArray(doc.querySelectorAll(SEL.drawer)).forEach(function (d) {
      if (d.getAttribute('data-section-id') !== id || (e.target && e.target.contains(d))) return;
      if (MP.layer.isOpen(d)) MP.layer.close({ silent: true });
      if (d.parentNode) d.parentNode.removeChild(d);
    });
  });
  doc.addEventListener('shopify:section:select', function (e) {
    var d = drawer();
    if (d && e.detail && d.getAttribute('data-section-id') === e.detail.sectionId) open();
  });
  doc.addEventListener('shopify:section:deselect', function (e) {
    var d = drawer();
    if (d && e.detail && d.getAttribute('data-section-id') === e.detail.sectionId) close();
  });

  MP.ready(function () { mount(); });

  window.MPCart = {
    __v5: true,
    open: function (opener) { return open(opener); },
    close: close,
    refresh: refresh,
    add: add,
    change: function (key, quantity) { return change(mainRoot(), key, quantity, 'change'); },
    applyCode: function (code) { return applyCode(mainRoot(), code); },
    removeCode: function (code) { return removeCode(mainRoot(), code); },
    isOpen: function () {
      var d = drawer();
      return !!(d && MP.layer.isOpen(d));
    },
    state: function () {
      return {
        item_count: state.item_count,
        total_price: state.total_price,
        codes: state.codes.slice(),
        applicable: state.applicable.slice()
      };
    }
  };
})();
